class VehicleModel {
  constructor() {
    this.VehicleId = null;
    this.VehicleType = '';
    this.Manufacturer = '';
    this.ModelName = '';
    this.Variant = '';
    this.Segment = '';
    this.Color = '';
    this.FuelType = '';
    this.EngineCC = '';
    this.LaunchDate = null;
    this.DiscontinueDate = null;
    this.Status = '';
    this.Remarks = '';
    this.DeleteInd = 0;
    this.CreatedDate = null;
    this.CreatedBy = null;
    this.ModifiedDate = null;
    this.ModifiedBy = null;
  }
}

export default VehicleModel;
